import { render, staticRenderFns } from "./MultimediaGallery.vue?vue&type=template&id=fb687584&scoped=true"
import script from "./MultimediaGallery.vue?vue&type=script&lang=js"
export * from "./MultimediaGallery.vue?vue&type=script&lang=js"
import style0 from "./MultimediaGallery.vue?vue&type=style&index=0&id=fb687584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb687584",
  null
  
)

export default component.exports